import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-qq",
  "use": "icon-qq-usage",
  "viewBox": "0 0 15 16.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 16.1\" id=\"icon-qq\"><title>资源 7</title><g id=\"icon-qq_图层_2\" data-name=\"图层 2\"><g id=\"icon-qq_图层_1-2\" data-name=\"图层 1\"><path d=\"M14.4,9.8l-.6-.9a4.3,4.3,0,0,0-.4-.7,2.1,2.1,0,0,0-.8-.6,2.8,2.8,0,0,0,.1-.9,6.6,6.6,0,0,0-.3-2.1A4.9,4.9,0,0,0,7.4,0a5.1,5.1,0,0,0-5,4.7,10.3,10.3,0,0,0-.2,2v.9a4.6,4.6,0,0,0-.7.7L1,9.1a4.3,4.3,0,0,0-.4.7c-.7,1.5-.8,2.8-.3,3.1s.8-.3,1.3-.9a6.5,6.5,0,0,0,1.6,2.1c-.8.3-1.3.7-1.3,1.3s1.2.7,2.8.7,2.3,0,2.6-.4h.3c.3.4,1.4.4,2.6.4s2.8.1,2.8-.7-.5-1-1.3-1.3a6,6,0,0,0,1.6-2.2c.5.7,1,1.1,1.4.9S15,11.3,14.4,9.8Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/qq.svg
// module id = R2jY
// module chunks = 75